import { useLanguage } from '../i18n/LanguageContext';

const ContactPage = () => {
  const { t } = useLanguage();

  return (
    <section className="panel contact-panel">
      <h2>{t.contact.title}</h2>
      <p>{t.contact.message}</p>
      <div className="contact-item">
        <span className="contact-label">{t.contact.email}</span>
        <a href="mailto:info@jebit.nl" className="contact-link">
          info@jebit.nl
        </a>
      </div>
      <div className="contact-item">
        <span className="contact-label">{t.contact.phone}</span>
        <a href="tel:+31630982710" className="contact-link">
          +31 6 30982710
        </a>
      </div>
      <div className="contact-item contact-item-multiline">
        <span className="contact-label">{t.contact.location}</span>
        <div className="contact-values">
          <span className="contact-value">Weert</span>
          <span className="contact-value">The Netherlands</span>
        </div>
      </div>
    </section>
  );
};

export default ContactPage;
